import axios from "axios";
import { API_BASE } from "../config.js";
import { getAccessToken } from "../auth/apiAuth.jsx";

const api = axios.create({
  baseURL: `${API_BASE}/api/data`,
  timeout: 30000,
});

api.interceptors.request.use((config) => {
  const tk = getAccessToken && getAccessToken();
  if (tk) config.headers.Authorization = `Bearer ${tk}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response) {
      const { status, data } = error.response;
      let msg =
        data?.error?.message ||
        (typeof data?.error === "string" ? data.error : null) ||
        data?.detail ||
        data?.message ||
        "Unknown error";
      const e = new Error(msg);
      e.status = status;
      e.details = data;
      if (status === 401) e.message = "Your session has expired. Please sign in again.";
      return Promise.reject(e);
    }
    return Promise.reject(error);
  }
);

/**
 * Get the reports catalogue
 */
export async function getReportsCatalogue() {
  const response = await api.get("/reports/catalogue");
  return response.data;
}

/**
 * Run a specific report
 */
export async function runReport(reportKey, options = {}) {
  const params = {};
  if (options.days) params.days = options.days;
  if (options.groupBy) params.groupBy = options.groupBy;
  if (options.horizonDays) params.horizonDays = options.horizonDays;
  if (options.company) params.company = options.company;
  if (options.vendorNo) params.vendorNo = options.vendorNo;

  const response = await api.get(`/reports/run/${reportKey}`, { params });
  return response.data;
}

/**
 * Export report data to CSV
 */
export function toCSV(report) {
  const { columns, rows } = report;
  const header = columns.map((c) => c.label).join(",");
  const body = rows
    .map((row) =>
      columns
        .map((c) => {
          const val = row[c.key];
          if (val === null || val === undefined) return "";
          const s = String(val);
          return s.includes(",") || s.includes('"') || s.includes("\n")
            ? `"${s.replace(/"/g, '""')}"`
            : s;
        })
        .join(",")
    )
    .join("\n");
  return header + "\n" + body;
}
